"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require("revalidate");

var _emailValidator = require("email-validator");

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (value && !/^(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/i.test(value)) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var isValidPath = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!value[0]) {
      return message;
    }
  };
}, function (field) {
  return field + " doesn't seem to be valid";
});

var _hasLengthGreaterThan = function _hasLengthGreaterThan(n) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      if (value.length <= n) {
        return message;
      }
    };
  }, function (field) {
    return field + " must be greater than " + n;
  });
};

var checkLengthLessThan = function checkLengthLessThan(count) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      if (value.length < count) {
        return "The message is too short. Please enter a brief description of your request.";
      }

      return null;
    };
  }, function (field) {
    return "The message can not be blank. Please enter a brief description of your request.";
  });
};

var validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.composeValidators)(_revalidate.isRequired, _hasLengthGreaterThan(2))("Name"),

  email: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidEmail)("Email"),

  photo: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidPath)("Photo"),

  institute: (0, _revalidate.composeValidators)(_revalidate.isRequired, _hasLengthGreaterThan(2))("Institute"),

  url: (0, _revalidate.composeValidators)(_revalidate.isRequired)("Url"),

  comments: (0, _revalidate.composeValidators)((0, _revalidate.isRequired)({
    message: "The message can not be blank. Please enter a brief description of your request."
  }), checkLengthLessThan(50))("Comments")
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/EducationalProgramFormValidation.js
// module id = 1247
// module chunks = 0